'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.DynamicField = exports.printField = void 0;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of'),
    _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf),
    _classCallCheck2 = require('babel-runtime/helpers/classCallCheck'),
    _classCallCheck3 = _interopRequireDefault(_classCallCheck2),
    _createClass2 = require('babel-runtime/helpers/createClass'),
    _createClass3 = _interopRequireDefault(_createClass2),
    _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn'),
    _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2),
    _inherits2 = require('babel-runtime/helpers/inherits'),
    _inherits3 = _interopRequireDefault(_inherits2),
    _typeof2 = require('babel-runtime/helpers/typeof'),
    _typeof3 = _interopRequireDefault(_typeof2),
    _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray'),
    _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2),
    _stringify = require('babel-runtime/core-js/json/stringify'),
    _stringify2 = _interopRequireDefault(_stringify),
    _slicedToArray2 = require('babel-runtime/helpers/slicedToArray'),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _extends2 = require('babel-runtime/helpers/extends'),
    _extends3 = _interopRequireDefault(_extends2),
    _regenerator = require('babel-runtime/regenerator'),
    _regenerator2 = _interopRequireDefault(_regenerator),
    _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator'),
    _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2),
    _promise = require('babel-runtime/core-js/promise'),
    _promise2 = _interopRequireDefault(_promise),
    _keys = require('babel-runtime/core-js/object/keys'),
    _keys2 = _interopRequireDefault(_keys),
    getCityIdSrcm = function () {
  var a = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function a(b) {
    var c;
    return _regenerator2.default.wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return a.next = 2, fetchProfileNoAuth('/api/v2/cities/' + b + '/', {}).then(function (a) {
              return {
                key: a.id,
                name: a.name + ', ' + (a.state ? a.state.name : '') + ', ' + (a.country ? a.country.name : '')
              };
            });

          case 2:
            return c = a.sent, a.abrupt('return', c);

          case 4:
          case 'end':
            return a.stop();
        }
      }
    }, a, this);
  }));
  return function () {
    return a.apply(this, arguments);
  };
}(),
    getStateIdSrcm = function () {
  var a = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function a(b) {
    var c;
    return _regenerator2.default.wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return a.next = 2, fetchProfileNoAuth('/api/v2/states/' + b + '/', {}).then(function (a) {
              return {
                key: a.id,
                name: a.name + ', ' + (a.country ? a.country.name : '')
              };
            });

          case 2:
            return c = a.sent, a.abrupt('return', c);

          case 4:
          case 'end':
            return a.stop();
        }
      }
    }, a, this);
  }));
  return function () {
    return a.apply(this, arguments);
  };
}();

exports.validateForm = validateForm;

var _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _default = require('./default'),
    _validations = require('../validations'),
    _choice_lists = require('../choice_lists'),
    _xor = require('lodash/xor'),
    _xor2 = _interopRequireDefault(_xor),
    _get = require('lodash/get'),
    _get2 = _interopRequireDefault(_get),
    _set = require('lodash/set'),
    _set2 = _interopRequireDefault(_set),
    _has = require('lodash/has'),
    _has2 = _interopRequireDefault(_has),
    _flattenDeep = require('lodash/flattenDeep'),
    _flattenDeep2 = _interopRequireDefault(_flattenDeep),
    _formatting = require('../formatting'),
    _cities = require('../cities'),
    _indiastates = require('../indiastates.json'),
    _indiastates2 = _interopRequireDefault(_indiastates),
    _countries = require('../countries.json'),
    _countries2 = _interopRequireDefault(_countries);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var STATIC_GATSBY_API_SITE = 'https://static-gatsby.web.app',
    gPlacesApi = 'https://us-central1-hfn-registration.cloudfunctions.net/gplaces/',
    fetchProfileNoAuth = function fetchProfileNoAuth(a, b) {
  var c = (0, _keys2.default)(b).map(function (a) {
    // this is a hack for now to convert array fields to comma seperated values. remove this sometime
    return a.endsWith('[]') || Array.isArray(b[a]) ? encodeURIComponent(a.replace('[]', '')) + '=' + encodeURIComponent(b[a].join(',')) : encodeURIComponent(a) + '=' + encodeURIComponent(b[a]);
  }).join('&');
  return fetch('https://profile.sahajmarg.org' + a + '?' + c, {
    method: 'GET',
    headers: {
      Accept: 'application/json, text/plain, */*',
      "Content-Type": 'application/json'
    }
  }).then(function (a) {
    return a.json();
  });
};

function getStates(a) {
  if (!a) return _promise2.default.resolve([]);
  var b = {
    country: _cities.countries_dict[a],
    page: 1,
    page_size: 200
  };
  return fetchProfileNoAuth('/api/v2/states/', b).then(function (a) {
    var b = {};
    return a.results.filter(function (a) {
      return !(a.name in b) && (b[a.name] = 1, !a.name.includes('NOT TO BE USED'));
    });
  });
}

var getGooglePlaces = function () {
  var a = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function a(b, c) {
    var d;
    return _regenerator2.default.wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            if (gPlacesApi) {
              a.next = 2;
              break;
            }

            return a.abrupt('return', []);

          case 2:
            return a.next = 4, fetch('https://us-central1-hfn-registration.cloudfunctions.net/gplaces/?session=' + b + '&input=' + c).then(function (a) {
              return a.json();
            }) // .then(( predictions ) => processAllPredictions(predictions, mySrcmConfig, noStrictId))
            .catch(function () {});

          case 4:
            if (d = a.sent, !Array.isArray(d)) {
              a.next = 9;
              break;
            }

            return a.abrupt('return', d.map(function (a) {
              return {
                key: a.id,
                name: a.name + ', ' + a.state + ', ' + a.country
              };
            }));

          case 9:
          case 10:
            return a.abrupt('return', []);

          case 11:
          case 'end':
            return a.stop();
        }
      }
    }, a, void 0);
  }));
  return function () {
    return a.apply(this, arguments);
  };
}();

function getSrcmApiCities(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 'abcdefgh';
  if (!a) return _promise2.default.resolve([]);
  var c = a.toLowerCase(),
      d = 'https://static-gatsby.web.app/srcmapi/cities/' + c.substring(0, 1) + '.json';
  return fetch(d).then(function (a) {
    return a.json();
  }).then(function (d) {
    var e = d.results.filter(function (a) {
      return !a.name.includes('NOT TO BE USED');
    }).map(function (a) {
      return {
        key: a.id,
        name: a.name + ', ' + a.state + ', ' + a.country
      };
    }).filter(function (a) {
      return a.name.toLowerCase().startsWith(c);
    }).filter(function (a, b) {
      return 10 > b;
    });

    if (1 > e.length) {
      var f = getGooglePlaces(b, a);
      return f;
    }

    return e;
  }).catch(function () {
    return [];
  });
}

function getSrcmApiCityId(a) {
  var b = this;
  if (!a) return _promise2.default.resolve([]);
  return fetch('https://static-gatsby.web.app/srcmapi/cities/id/' + a + '.json').then(function (a) {
    return a.json();
  }).then(function (a) {
    return [{
      key: a.id,
      name: a.name + ', ' + (a.state ? a.state + ', ' : '') + a.country
    }];
  }).catch(function () {
    var c = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function c() {
      var d;
      return _regenerator2.default.wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              return b.next = 3, getCityIdSrcm(a);

            case 3:
              return d = b.sent, b.prev = 4, b.abrupt('return', [d]);

            case 9:
              return b.prev = 9, b.t0 = b['catch'](4), b.abrupt('return', []);

            case 12:
            case 'end':
              return b.stop();
          }
        }
      }, c, b, [[4, 9]]);
    }));
    return function () {
      return c.apply(this, arguments);
    };
  }());
}

function getSrcmApiStates(a) {
  if (!a) return _promise2.default.resolve([]);
  var b = a.toLowerCase(),
      c = 'https://static-gatsby.web.app/srcmapi/states/' + b.substring(0, 1) + '.json';
  return fetch(c).then(function (a) {
    return a.json();
  }).then(function (a) {
    return a.results.filter(function (a) {
      return !a.name.includes('NOT TO BE USED');
    }).map(function (a) {
      return {
        key: a.id,
        name: a.name + ', ' + a.country
      };
    }).filter(function (a) {
      return a.name.toLowerCase().startsWith(b);
    }).filter(function (a, b) {
      return 10 > b;
    });
  }).catch(function () {
    return [];
  });
}

function getSrcmApiStateId(a) {
  var b = this;
  if (!a) return _promise2.default.resolve([]);
  return fetch('https://static-gatsby.web.app/srcmapi/states/id/' + a + '.json').then(function (a) {
    return a.json();
  }).then(function (a) {
    return [{
      key: a.id,
      name: a.name + ', ' + a.country
    }];
  }).catch(function () {
    var c = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function c() {
      var d;
      return _regenerator2.default.wrap(function (b) {
        for (;;) {
          switch (b.prev = b.next) {
            case 0:
              return b.next = 3, getStateIdSrcm(a);

            case 3:
              return d = b.sent, b.prev = 4, b.abrupt('return', [d]);

            case 9:
              return b.prev = 9, b.t0 = b['catch'](4), b.abrupt('return', []);

            case 12:
            case 'end':
              return b.stop();
          }
        }
      }, c, b, [[4, 9]]);
    }));
    return function () {
      return c.apply(this, arguments);
    };
  }());
}

function getSrcmApiCenters(a) {
  if (!a) return _promise2.default.resolve([]);
  var b = a.toLowerCase(),
      c = 'https://static-gatsby.web.app/srcmapi/groups/center/' + b.substring(0, 1) + '.json';
  return fetch(c).then(function (a) {
    return a.json();
  }).then(function (a) {
    return a.results.filter(function (a) {
      return !a.name.includes('NOT TO BE USED');
    }).map(function (a) {
      return {
        key: a.id,
        name: '' + a.name
      };
    }).filter(function (a) {
      return a.name.toLowerCase().startsWith(b);
    }).filter(function (a, b) {
      return 10 > b;
    });
  }).catch(function () {
    return [];
  });
}

function getSrcmApiGroupId(a) {
  var b = this;
  if (!a) return _promise2.default.resolve([]);
  return fetch('https://static-gatsby.web.app/srcmapi/groups/id/' + a + '.json').then(function (a) {
    return a.json();
  }).then(function (a) {
    return [{
      key: a.id,
      name: '' + a.name
    }];
  }).catch(function () {
    var a = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function a() {
      return _regenerator2.default.wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.abrupt('return', []);

            case 1:
            case 'end':
              return a.stop();
          }
        }
      }, a, b);
    }));
    return function () {
      return a.apply(this, arguments);
    };
  }());
}

function getSrcmApiCountryId(a) {
  var b = this;
  if (!a) return _promise2.default.resolve([]);
  return fetch('https://static-gatsby.web.app/srcmapi/countries/id/' + a + '.json').then(function (a) {
    return a.json();
  }).then(function (a) {
    return [{
      key: a.id,
      name: '' + a.name
    }];
  }).catch(function () {
    var a = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function a() {
      return _regenerator2.default.wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.abrupt('return', []);

            case 1:
            case 'end':
              return a.stop();
          }
        }
      }, a, b);
    }));
    return function () {
      return a.apply(this, arguments);
    };
  }());
}

function getSrcmApiCountries(a) {
  var b = a.toLowerCase();
  return fetch('https://static-gatsby.web.app/srcmapi/countries/all.json').then(function (a) {
    return a.json();
  }).then(function (a) {
    return a.results.filter(function (a) {
      return !a.name.includes('NOT TO BE USED');
    }).map(function (a) {
      return {
        key: a.id,
        name: '' + a.name
      };
    }).filter(function (a) {
      return a.name.toLowerCase().startsWith(b);
    });
  }).catch(function () {
    return [{
      key: 358,
      name: 'India'
    }];
  });
}

function getSrcmApiZones(a) {
  var b = a.toLowerCase();
  return fetch('https://static-gatsby.web.app/srcmapi/groups/zone/all.json').then(function (a) {
    return a.json();
  }).then(function (a) {
    return a.results.filter(function (a) {
      return !a.name.includes('NOT TO BE USED');
    }).map(function (a) {
      return {
        key: a.id,
        name: '' + a.name
      };
    }).filter(function (a) {
      return a.name.toLowerCase().includes(b);
    });
  }).catch(function () {
    return [{
      key: 1,
      name: 'SRCM'
    }];
  });
}

function getSrcmApiEventCategories(a) {
  var b = a.toLowerCase();
  return fetch('https://static-gatsby.web.app/srcmapi/event-categories/all.json').then(function (a) {
    return a.json();
  }).then(function (a) {
    return a.results.filter(function (a) {
      return !a.name.includes('NOT TO BE USED');
    }).map(function (a) {
      return {
        key: a.id,
        name: '' + a.complete_name
      };
    }).filter(function (a) {
      return a.name.toLowerCase().startsWith(b);
    });
  }).catch(function () {
    return [{
      key: 1,
      name: 'Heartfulness'
    }];
  });
}

function getSrcmApiEventCategoryId() {
  return getSrcmApiEventCategories('');
}

var derivedField = function derivedField(a, b) {
  var c;
  return 'gender' === a ? (c = (0, _extends3.default)({}, b, {
    options: _choice_lists.gender_options
  }), {
    type: 'select',
    params: c
  }) : 'age' === a ? (c = (0, _extends3.default)({}, b), c.props = (0, _extends3.default)({}, b.props, {
    max: 99,
    min: 1
  }), {
    type: 'number',
    params: c
  }) : 'srcm_city_id' === a || 'city' === a ? (c = (0, _extends3.default)({}, b, {
    options: [],
    props: (0, _extends3.default)({}, b.props, {
      remoteItemsApi: getSrcmApiCities,
      remoteKeyApi: getSrcmApiCityId
    })
  }), {
    type: 'autosuggest',
    params: c
  }) : 'srcm_event_category_id' === a || 'event-category' === a ? (c = (0, _extends3.default)({}, b, {
    options: [],
    props: (0, _extends3.default)({}, b.props, {
      remoteItemsApi: getSrcmApiEventCategories,
      remoteKeyApi: getSrcmApiEventCategoryId
    })
  }), {
    type: 'autosuggest',
    params: c
  }) : 'srcm_center_id' === a ? (c = (0, _extends3.default)({}, b, {
    options: [],
    props: (0, _extends3.default)({}, b.props, {
      remoteItemsApi: getSrcmApiCenters,
      remoteKeyApi: getSrcmApiGroupId
    })
  }), {
    type: 'autosuggest',
    params: c
  }) : 'srcm_zone_id' === a ? (c = (0, _extends3.default)({}, b, {
    options: [],
    props: (0, _extends3.default)({}, b.props, {
      remoteItemsApi: getSrcmApiZones,
      remoteKeyApi: getSrcmApiGroupId
    })
  }), {
    type: 'autosuggest',
    params: c
  }) : 'srcm_country_id' === a ? (c = (0, _extends3.default)({}, b, {
    options: [],
    props: (0, _extends3.default)({}, b.props, {
      remoteItemsApi: getSrcmApiCountries,
      remoteKeyApi: getSrcmApiCountryId
    })
  }), {
    type: 'autosuggest',
    params: c
  }) : 'srcm_state_id' === a ? (c = (0, _extends3.default)({}, b, {
    options: [],
    props: (0, _extends3.default)({}, b.props, {
      remoteItemsApi: getSrcmApiStates,
      remoteKeyApi: getSrcmApiStateId
    })
  }), {
    type: 'autosuggest',
    params: c
  }) : 'center' === a ? (c = (0, _extends3.default)({}, b, {
    options: _cities.city_options
  }), {
    type: 'autosuggest_object',
    params: c
  }) : 'state' === a ? (c = (0, _extends3.default)({}, b, {
    optionsPromise: {
      promise: function c(a) {
        var b = a.countryName;
        return getStates(b);
      }
    },
    props: (0, _extends3.default)({
      promiseParams: {
        countryName: 'India'
      }
    }, b.props)
  }), {
    type: 'autosuggest',
    params: c
  }) : 'indiastate' === a ? (c = (0, _extends3.default)({}, b, {
    options: _indiastates2.default
  }), {
    type: 'autosuggest',
    params: c
  }) : 'country' === a ? (c = (0, _extends3.default)({}, b, {
    options: _countries2.default
  }), {
    type: 'autosuggest',
    params: c
  }) : 'email' === a ? (c = (0, _extends3.default)({}, b), c.props = (0, _extends3.default)({}, b.props, {
    pattern: _validations.email_regex,
    title: 'valid email id'
  }), {
    type: 'email',
    params: c
  }) : 'abhyasiid' === a ? (c = (0, _extends3.default)({}, b), c.props = (0, _extends3.default)({}, b.props, {
    transform: 'abhyasiid',
    pattern: _validations.abhyasiid_regex,
    title: 'valid SRCM ID or Heartfulness ID'
  }), {
    type: 'text',
    params: c
  }) : 'pnr' === a ? (c = (0, _extends3.default)({}, b), c.props = (0, _extends3.default)({}, b.props, {
    transform: 'pnr',
    pattern: _validations.pnr_regex,
    title: 'valid PNR XX-XXXX-XXXX'
  }), {
    type: 'text',
    params: c
  }) : 'phone' === a ? (c = (0, _extends3.default)({}, b), c.props = (0, _extends3.default)({}, b.props, {
    validator: 'phone'
  }), {
    type: 'text',
    params: c
  }) : {
    type: a,
    params: b
  };
};

function validateForm(a, b, c, e) {
  function g(a) {
    function b(a) {
      //console.log("AA", val);
      if ('date' === e.type || 'datetimetz' === e.type) {
        if ((0, _has2.default)(e, 'props.maxDate') && a > e.props.maxDate) return 'Date outside allowed range: ' + e.label;
        if ((0, _has2.default)(e, 'props.minDate') && a < e.props.minDate) return 'Date outside allowed range: ' + e.label;
      }

      return 'phone' === e.type && (0, _default.isnotnull)(a) && !(0, _validations.validatePhoneNumber)(a) ? 'Invalid Phone Number: ' + e.label : (0, _has2.default)(e, 'validator') && (0, _validations.validateField)(e.validator, l, e.name) ? 'Invalid Value: ' + e.label : void 0;
    }

    var c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : '',
        e = void 0;
    if ('dynamic' in a && 'function' == typeof a.dynamic ? e = (0, _extends3.default)({}, a, a.dynamic(h)) : Array.isArray(a.dynamic) ? (e = (0, _extends3.default)({}, a), a.dynamic.map(function (b) {
      var c = (0, _slicedToArray3.default)(b, 2),
          d = c[0],
          f = c[1],
          g = d;

      if (Array.isArray(d) && (g = d[0]), ['label', 'hide', 'type', 'props', 'subFormFields'].includes(g) || g.startsWith('props.')) {
        var i = (0, _validations.computeRule)(f, h, a.name);
        '##IGNORE##' !== i && (0, _set2.default)(e, d, i);
      }
    })) : e = (0, _extends3.default)({}, a), 'subform:single' === e.type) return void e.subFormFields.map(function (b) {
      return g((0, _extends3.default)({}, b, {
        name: 'string' == typeof e.name ? [e.name, b.name] : e.name.concat([b.name])
      }));
    }); //console.log("In Form Validate", f);

    if ('subform:multiple' === e.type) {
      var o = (0, _get2.default)(h, e.name, void 0);
      return void (!o || o.map(function (a, b) {
        return e.subFormFields.map(function (c) {
          return g((0, _extends3.default)({}, c, {
            name: 'string' == typeof e.name ? [e.name, b, c.name] : e.name.concat([b, c.name])
          }));
        });
      }));
    }

    var i = 'toggle' === e.type || 'checkbox' === e.type,
        j = (0, _get2.default)(e, 'hide', !1),
        k = (0, _get2.default)(e, ['props', 'required'], !0) && !i && !j && 'statichtml' !== e.type,
        l = (0, _get2.default)(h, e.name, void 0),
        m = !l || Array.isArray(l) && 0 === l.length;
    k && m && d.push('Missing Value: ' + e.label);
    var n = []; //console.log(newval);

    n = Array.isArray(l) ? l.map(b) : [b(l)], n.filter(function (a) {
      return !!a;
    }).map(function (a) {
      return d.push(a);
    });
  } //console.log("calling form validator", props.formValidator);
  //alert(JSON.stringify(d));


  var h = e,
      d = [];
  return (a.map(g), 0 < d.length) ? d.join('<br/>') : 'function' == typeof b ? b(h, c) : b && Array.isArray(b) && (0, _validations.validateConstraints)(b, h);
}

function process_computed(a, b, c) {
  var d = (0, _get2.default)(b, c);

  if (!!d) {
    var e = (0, _extends3.default)({}, a);
    return d.map(function (a) {
      var b = (0, _slicedToArray3.default)(a, 2),
          c = b[0],
          d = b[1];

      if (Array.isArray(d)) {
        var f = (0, _validations.computeRule)(d, e, c);
        '##IGNORE##' !== f && (0, _set2.default)(e, c, f);
      }
    }), e;
  }

  return a;
}

function process_computed_all(a, b) {
  function c(a, b) {
    a.map(function (a) {
      var e;
      if ('subform:single' === a.type) e = b.concat([a.name]), c(a.subFormFields, e);else if ('subform:multiple' === a.type) e = b.concat([a.name, 0]), c(a.subFormFields, e);else if ('computed' in a) {
        e = b.concat([a.name]);
        var f = (0, _validations.computeRule)(a.computed, d, e);
        '##IGNORE##' !== f && (0, _set2.default)(d, e, f);
      }
    });
  }

  var d = (0, _extends3.default)({}, a);
  return c(b, []), d;
}

var initMain = function initMain(a) {
  function b(a, c) {
    Array.isArray(a) || (void 0, alert('formFields/subFormFields needs to an Array only!!!')), a.map(function (a) {
      var d;
      'subform:single' === a.type ? (d = c.concat([a.name]), b(a.subFormFields, d)) : 'subform:multiple' === a.type ? (d = c.concat([a.name, 0]), b(a.subFormFields, d)) : (d = c.concat([a.name]), 'defaultValue' in a && (0, _set2.default)(g, d, a.defaultValue), 'computed' in a && (0, _flattenDeep2.default)(a.computed).filter(function (a) {
        return 'string' == typeof a && a.startsWith(':') && !a.startsWith('::');
      }).map(function (a) {
        return a.replace(':', '');
      }).map(function (a) {
        return a.replace('~', '');
      }).map(function (b) {
        var c = (0, _get2.default)(h, b, []);
        c.push([d, a.computed]), (0, _set2.default)(h, b, c);
      }));
    });
  }

  var c = a.defaultValues,
      e = a.formFields,
      g = {},
      h = {};
  b(e, []), !!c && 0 < (0, _keys2.default)(c).length && (g = JSON.parse((0, _stringify2.default)(c)));
  var i = process_computed_all(g, e);
  return {
    d: i,
    i: i,
    errors: '',
    saving: !1,
    computed_fields: h
  };
};

function reducer(a, b) {
  var c;

  switch (b.type) {
    case 'reset':
      //newd = process_computed(state.d, computed_fields);
      //var newd = process_computed_all(d, formFields);
      return {
        errors: '',
        saving: !1,
        d: a.i
      };

    case 'reset_saving':
      return (0, _extends3.default)({}, a, {
        errors: '',
        saving: !1
      });

    case 'set_kv':
      return c = (0, _extends3.default)({}, a.d), (0, _set2.default)(c, b.key, b.value), c = process_computed(c, a.computed_fields, b.key), (0, _extends3.default)({}, a, {
        d: c
      });

    case 'set_kv_multiple':
      c = (0, _extends3.default)({}, a.d); // Array of values (e.g. multiselect)

      var d = (0, _get2.default)(c, b.key, []),
          e = (0, _xor2.default)(d, [b.value]);
      return (0, _set2.default)(c, b.key, e), c = process_computed(c, a.computed_fields, b.key), (0, _extends3.default)({}, a, {
        d: c
      });

    case 'saving':
      return (0, _extends3.default)({}, a, {
        errors: '',
        saving: !0
      });

    case 'errors':
      return (0, _extends3.default)({}, a, {
        errors: b.msg,
        saving: !1
      });
  }

  return a;
}

var DynamicForm = function DynamicForm(a) {
  function b(a) {
    o({
      type: 'errors',
      msg: a
    });
  }

  function c() {
    o({
      type: 'reset_saving'
    }), a.onDiscard instanceof Function && a.onDiscard();
  }

  function e(b) {
    b.preventDefault(), o({
      type: 'reset'
    }), a.onDiscard instanceof Function && a.onDiscard();
  }

  function f(a, b) {
    var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : 'single';
    'multiple' === c ? o({
      type: 'set_kv_multiple',
      key: b,
      value: a
    }) : o({
      type: 'set_kv',
      key: b,
      value: a
    });
  }

  function g(a) {
    var b = a.name,
        c = a.defaultValue,
        e = a.label,
        f = a.type,
        g = a.listField,
        h = a.subFormFields,
        i = g || 'multiautosuggest' === f || 'multiselect' === f || 'multicheckbox' === f ? [] : 'subform:single' !== f && 'subform:multiple' !== f || !h ? '' : {},
        j = (0, _get2.default)(p, b, i),
        k = (0, _get2.default)(d, b, i);
    return {
      value: j,
      label: e,
      oldValue: k,
      defaultValue: c
    };
  }

  function h(a) {
    var b = (0, _get2.default)(p, a, []);
    (0, _set2.default)(p, a), o({
      type: 'set_kv',
      key: a,
      value: [].concat((0, _toConsumableArray3.default)(b), [{}])
    });
  }

  function j(a, b) {
    var c = (0, _get2.default)(p, a, []);
    o({
      type: 'set_kv',
      key: a,
      value: c.filter(function (a, c) {
        return c !== b;
      })
    });
  }

  function k(b) {
    var c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : -1; // if the required field passed is not in the formFields, m comes as undefined

    if (void 0 === b) return null;
    var d = a.inlineForm,
        e = a.printOnly,
        g = b.name,
        i = b.defaultValue,
        l = b.label,
        m = b.computed,
        n = b.hide,
        o = b.type,
        q = b.props,
        r = b.options,
        s = b.optionsPromise,
        t = b.dynamic,
        u = b.listField,
        w = b.subFormFields,
        x = (0, _get2.default)(p, g, i || (u || 'multiautosuggest' === o || 'multiselect' === o || 'multicheckbox' === o ? [] : ('subform:single' === o || 'subform:multiple' === o) && w ? {} : '')),
        y = g.toString(); //console.log("In renderField: ", m, kk, name, "VALUE:", value);
    // recursion for subforms

    if (('subform:single' === o || 'subform:multiple' === o) && !!w) {
      var v = function v(a, b) {
        return 'object' === ('undefined' == typeof d ? 'undefined' : (0, _typeof3.default)(d)) && 'container' in d ? d.container(a, b) : a + b;
      },
          z = function z(a) {
        return 'object' === ('undefined' == typeof d ? 'undefined' : (0, _typeof3.default)(d)) && 'row' in d ? d.row(a) : a;
      },
          A = function A(a) {
        return 'object' === ('undefined' == typeof d ? 'undefined' : (0, _typeof3.default)(d)) && 'col' in d ? d.col(a) : a;
      },
          B = function B(a) {
        return 'object' === ('undefined' == typeof d ? 'undefined' : (0, _typeof3.default)(d)) && 'headcol' in d ? d.headcol(a) : a;
      },
          C = d.nolabels;

      if ('subform:single' === o) {
        var F = v(z(w.map(function (a, b) {
          return B(a.label, y + c + 'h' + b);
        }), y + c + 'r-1'), z(w.map(function (a, b) {
          return A(k((0, _extends3.default)({}, a, {
            name: 'string' == typeof g ? [g, a.name] : g.concat([a.name])
          }, C ? {
            label: ''
          } : {}), y + 'k' + c + 'f' + b), y + 'k' + c + 'c' + b);
        }), y + c + 'r-2'));
        return F;
      }

      return v(z(_react2.default.createElement(_react2.default.Fragment, null, B('', y + c + 's'), w.map(function (a, b) {
        return B(a.label, y + c + 'h' + b);
      })), y + c + 'r-1'), _react2.default.createElement(_react2.default.Fragment, null, x.map(function (a, b) {
        return z(_react2.default.createElement(_react2.default.Fragment, null, B(b + 1, y + 'k' + c + 'v' + b + 's'), w.map(function (a, d) {
          return A(k((0, _extends3.default)({}, a, {
            name: 'string' == typeof g ? [g, b, a.name] : g.concat([b, a.name])
          }, C ? {
            label: ''
          } : {}), y + 'k' + c + 'v' + b + 'f' + d), y + 'k' + c + 'v' + b + 'c' + d);
        }), (0, _get2.default)(q, 'delete', !1) && B(_react2.default.createElement('span', {
          onClick: function a() {
            return j(g, b);
          }
        }, _react2.default.createElement(_default.DeleteButton, null)), y + 'k' + c + 'v' + b + 'd')), y + 'k' + c + 'v' + b);
      }), (0, _get2.default)(q, 'add', !1) && _react2.default.createElement('span', {
        onClick: function a() {
          return h(g);
        }
      }, _react2.default.createElement(_default.AddButton, null))));
    }

    q || (q = {}), (0, _set2.default)(q, 'required', (0, _get2.default)(q, 'required', !0));
    var D = {
      name: g,
      value: x,
      label: l,
      hide: n,
      props: q,
      type: o || 'text',
      setKV: f,
      subFormFields: w
    };
    if (Array.isArray(r) && (D.options = r), !s || (D.optionsPromise = s), 'function' == typeof t ? D = (0, _extends3.default)({}, D, t(p, g)) : Array.isArray(t) && (D = (0, _extends3.default)({}, D, {
      props: (0, _extends3.default)({}, D.props)
    }), t.map(function (a) {
      var b = (0, _slicedToArray3.default)(a, 2),
          c = b[0],
          d = b[1],
          e = c;

      if (Array.isArray(c) && (e = c[0]), ['label', 'hide', 'type', 'props', 'subFormFields'].includes(e) || e.startsWith('props.')) {
        var f = (0, _validations.computeRule)(d, p, g);
        '##IGNORE##' !== f && (0, _set2.default)(D, c, f);
      }
    }), void 0), 'hide' in D && D.hide) return null;
    if (('noInput' in q && q.noInput || !!m) && ((0, _set2.default)(D.props, 'readOnly', !0), (0, _set2.default)(D.props, 'borderless', !0)), (0, _get2.default)(a, 'hideSubmit') && (0, _set2.default)(D.props, 'hideSubmit', !0), 'gridInline' in q && !!q.gridInline && ((0, _set2.default)(D.props, ['styles', 'root', 'width'], '' + q.gridInline), (0, _set2.default)(D.props, ['styles', 'root', 'display'], 'inline-grid')), 'gridWidth' in q && !!q.gridWidth && (0, _set2.default)(D.props, ['styles', 'root', 'width'], '' + q.gridWidth), e && 'statichtml' !== D.type) return 'function' == typeof e ? e(D.label, printField(D.type, D.value, D.options), 'k' + D.name) : _react2.default.createElement('div', {
      key: 'k' + D.name
    }, _react2.default.createElement('b', null, D.label), ': ', printField(D.type, D.value, D.options));
    var E = derivedField(D.type, D); //console.log(X.params);

    return (0, _default.fieldSwitcher)(c, E.type, E.params, d, u);
  }

  var l = (0, _react.useReducer)(reducer, initMain(a)),
      m = (0, _slicedToArray3.default)(l, 2),
      n = m[0],
      o = m[1],
      p = n.d,
      d = n.i,
      i = n.errors,
      q = n.saving,
      r = a.formTitle,
      s = a.formClassName,
      t = a.formStyle; //console.log("Dynamic Form", props);

  return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('form', {
    className: s,
    style: t ? t : {},
    onSubmit: function onSubmit(d) {
      d.preventDefault(), d.stopPropagation();
      var e = validateForm(a.formFields, a.formValidator, a.defaultValues, p);
      return !e ? void (o({
        type: 'saving'
      }), a.onSubmit instanceof Function && a.onSubmit(p, c, b)) : void o({
        type: 'errors',
        msg: e
      });
    }
  }, _react2.default.createElement(ErrorBoundary, null, !!r && _react2.default.createElement('div', null, '  ', r, ' '), function () {
    var b = a.formFields,
        c = a.formLayout,
        f = a.buttons,
        h = a.hideSubmit,
        j = a.hideDiscard,
        l = a.printOnly,
        m = a.newFormLayout,
        n = !l;
    'object' !== ('undefined' == typeof f ? 'undefined' : (0, _typeof3.default)(f)) && (f = {});

    var o = f,
        r = o.submitButton,
        s = o.discardButton,
        t = o.displayErrors,
        u = o.displayLoading,
        v = n && i && (t ? t(i) : _react2.default.createElement(_default.Errors, {
      text: i
    })),
        w = n && q && (u ? u('saving') : _react2.default.createElement(_default.Loading, null)),
        x = n && !(h || q) && (r || _react2.default.createElement(_default.SubmitButton, null)),
        y = n && !(j || q) && _react2.default.createElement('span', {
      onClick: e
    }, s ? s : _react2.default.createElement(_default.DiscardButton, null));

    if (null !== m && m !== void 0 && m instanceof Function) {
      var z = function z(a) {
        return k(b.find(function (b) {
          return b.name === a;
        }));
      },
          A = function A(a) {
        return g(b.find(function (b) {
          return b.name === a;
        }));
      },
          B = function B() {
        return (0, _stringify2.default)(d) !== (0, _stringify2.default)(p);
      },
          C = m({
        getField: A,
        renderField: z,
        renderErrors: v,
        renderLoading: w,
        renderSubmitBtn: x,
        renderDiscardBtn: y,
        isDirty: B
      });

      return C;
    }

    if (null !== c && void 0 !== c && c instanceof Function) {
      var D = function D(a) {
        return k(b.find(function (b) {
          return b.name === a;
        }));
      },
          E = c(D, v, w, x, y);

      return E;
    }

    var F = b.map(k);
    return _react2.default.createElement(_react2.default.Fragment, null, F, n && _react2.default.createElement('br', null), n && _react2.default.createElement('br', null), i && v, q && w, x, y);
  }())));
},
    printField = exports.printField = function (a, b, c) {
  if (Array.isArray(b)) return b.map(function (b) {
    return printField(a, b, c);
  }).join(', ');
  if ('boolean' == typeof b) return (0, _formatting.doFormatYesNo)(b);
  if ('date' === a) return (0, _formatting.doFormatShortDate)(b);
  if ('datetimetz' === a) return (0, _formatting.doFormat)('datelocale', b);
  if ('firebasefile' === a) return (0, _formatting.doFormat)('firebaseobject', b);
  if ('htmlfield' === a) return _react2.default.createElement('div', {
    dangerouslySetInnerHTML: b
  });

  if ('object' === ('undefined' == typeof c ? 'undefined' : (0, _typeof3.default)(c))) {
    var d = c.find(function (a) {
      return a.name === b;
    });
    if (!!d) return (0, _get2.default)(d, 'label', b);
  }

  return b;
};

exports.default = DynamicForm;

var DynamicField = exports.DynamicField = function (a) {
  var b = derivedField(a.type, a),
      c = b.type,
      d = b.params,
      e = (0, _extends3.default)({}, d);
  return e.setKV = function (b) {
    return a.onChange ? a.onChange(b) : {};
  }, (0, _default.fieldSwitcher)(a.name, c, e, !1);
},
    ErrorBoundary = function (a) {
  function b(a) {
    (0, _classCallCheck3.default)(this, b);
    var c = (0, _possibleConstructorReturn3.default)(this, (b.__proto__ || (0, _getPrototypeOf2.default)(b)).call(this, a));
    return c.state = {
      hasError: !1
    }, c;
  }

  return (0, _inherits3.default)(b, a), (0, _createClass3.default)(b, [{
    key: 'componentDidCatch',
    value: function a() {}
  }, {
    key: 'render',
    value: function a() {
      return this.state.hasError ? _react2.default.createElement('h1', null, 'Something went wrong.') : this.props.children;
    }
  }], [{
    key: 'getDerivedStateFromError',
    value: function a() {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: !0
      };
    }
  }]), b;
}(_react2.default.Component); // export const renderDynamicField = (m, kidx = undefined) => {
//   // if the required field passed is not in the formFields, m comes as undefined
//   if (m === undefined) {
//     return null;
//   }
//   let { name, defaultValue, label, type, props, options, onChange } = m;
//   let value = defaultValue || "";
//   if (!props) {
//     props = {};
//     if (!props.required) {
//       props.required = true;
//     }
//   }
//   let params = { name, value, label, props: props, type: type || "text", onChange };
//   if (Array.isArray(options)) {
//     params.options = options;
//   }
//   let X = derivedField(type, params);
//   return fieldSwitcher(kidx, X.type, X.params, false);
// }